const BigNumber = require('bignumber.js');

/**
 * Encode a number in base 36.
 *
 * @param {number} value
 *
 * @return {string}
 */
const base36EncodeNumber = (value) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    if (!Number.isInteger(value)) {
        throw new Error('value is not an integer number');
    }
    let result = '';
    let mod = 0;
    do {
        mod = value % 36;
        result = alphabet.charAt(mod) + result;
        value = Math.floor(value / 36);
    } while (value > 0);
    return result;
};

const fromMinorUnit = (amount) => {
    let n = new BigNumber(amount);
    return n.shiftedBy(-2).toNumber();
};

/**
 * Flip the sign of all the numbers in the given object.
 *
 * @param {Object<number>} obj
 * @returns {Object<number>}
 */
const negateObjectValues = (obj) => {
    let newObj = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key] = -parseFloat(obj[key]);
        }
    }
    return newObj;
};

/**
 * @param {number} value
 * @param {number} decimals
 *
 * @return {number}
 */
const preciseRound = (value, decimals) => {
    return parseFloat(
        (Math.round((value * (10 ** decimals)) + ((value >= 0 ? 1 : -1) * 0.001)) / (10 ** decimals)).toFixed(decimals)
    );
};

const safeMultiply = (a, b) => {
    return new BigNumber(a)
        .multipliedBy(b)
        .toNumber();
};

/**
 * @param {{}} obj
 * @return {number}
 */
const sumObject = (obj) => {
    let total = 0;
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            total += parseFloat(obj[key]);
        }
    }
    return total;
};

const toMinorUnit = (amount) => {
    let n = new BigNumber(amount);
    return n.shiftedBy(2).toNumber();
};

module.exports = {
    base36EncodeNumber,
    fromMinorUnit,
    negateObjectValues,
    preciseRound,
    safeMultiply,
    sumObject,
    toMinorUnit,
};
